// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:38:02.908Z
// Property: Colonial Gardens Apartments (ID: 6767906449167513)
// Collections: 34 amenities, 2 floorplans (live), 13 photos, 39 POIs, 5 reviews, 4 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167513",
  "property_external_id": "5685513",
  "property_zillow_url": "https://www.zillow.com/apartments/georgetown-ky/colonial-gardens-apartments/5Xt8LZ/",
  "property_apartments_url": "https://www.apartments.com/colonial-gardens-apartments-georgetown-ky/l2mzb7f/",
  "property_google_business_url": "https://www.google.com/maps/place/Colonial+Gardens+Apartments/@38.2327881,-84.5804712,931m/data=!3m2!1e3!4b1!4m6!3m5!1s0x88423e4b4ad94883:0x8bc8e01af3fcb53!8m2!3d38.2327881!4d-84.5804712!16s%2Fg%2F1tj7x1hd?entry=ttu&g_ep=EgoyMDI2MDUyNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "58543610927",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "RealPage",
  "property_status": null,
  "property_slug": "colonial-gardens-apartments",
  "property_name": "Colonial Gardens Apartments",
  "property_website_url": "https://www.colonialgardensliving.com/",
  "property_domain": "https://www.colonialgardensliving.com/",
  "property_address": "271 Williamsburg Ln",
  "property_full_address": "271 Williamsburg Ln, Georgetown, KY 40324",
  "property_address_1": "271 Williamsburg Ln",
  "property_address_2": null,
  "property_address_city": "Georgetown",
  "property_address_state": "KY",
  "property_address_zip_full": "40324-2546",
  "property_address_zip": "40324",
  "property_address_country": "US",
  "property_address_county": "Scott County",
  "property_neighborhood_address": "Scott County",
  "property_address_latitude": "38.2327113",
  "property_address_longitude": "-84.5803533",
  "property_email": "colonialgardens@dietzpropertygroup.com",
  "property_phone": "(502) 867-0528",
  "property_call_tracking_phone": "502-316-6061",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://www.dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Colonial Gardens in Georgetown, KY, our spacious two and three-bedroom apartments blend comfort with style. Enjoy modern amenities like deluxe appliances, private patios, and in-unit laundry. With off-street parking and select remodeled units, your perfect home awaits. Connect with us today to schedule a tour or view our availability!",
  "property_long_description": "When you call Colonial Gardens Apartments home, you'll find yourself in a quiet setting enhanced with a variety of unique amenities. Our community offers two and three bedroom floor plans spaciously designed with comfort in mind. The professional, on-site management staff will assist you in meeting all of your needs. We are an Income-Restricted property, so please feel free to give the property manager a call to learn more about the qualifications for acceptance.\n\n- Lease for a Year | Stay for a Decade",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-d18a-72ca-aec1-6c0dc503fa5a.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with brick and siding, balconies, and parking lot.",
    "public_id": "019e46e3-d18a-72ca-aec1-6c0dc503fa5a",
    "storage_key": "property/6767906449167513/019e46e3-d18a-72ca-aec1-6c0dc503fa5a.webp",
    "width": 900,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "48",
  "property_year_built": "1997",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "30",
  "property_pet_restrictions": "Cats allowed, maximum weight 30 lb each, maximum 2 animals per unit, no dogs allowed.",
  "property_pet_policy_description": "Cats are allowed at this property: maximum weight 30 lb each. Pet deposit: $300 per cat. Monthly pet rent: $25 per cat. No dogs allowed. Maximum 2 animals per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://colonialgardensky.loftliving.com/",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019ef53f-d2de-777b-8c38-461800eefbfa.webp",
  "property_primary_logo_media": {
    "alt_text": "Colonial Gardens Apartments logo",
    "public_id": "019ef53f-d2de-777b-8c38-461800eefbfa",
    "storage_key": "property/6767906449167513/019ef53f-d2de-777b-8c38-461800eefbfa.webp",
    "width": 2000,
    "height": 2000
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019ef53f-d2de-777b-8c38-461800eefbfa.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019ef53f-d2de-777b-8c38-461800eefbfa",
    "storage_key": "property/6767906449167513/019ef53f-d2de-777b-8c38-461800eefbfa.webp",
    "width": 2000,
    "height": 2000
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019ef53f-d2e8-757f-a66b-3077210ce38e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Colonial Gardens Apartments logo",
    "public_id": "019ef53f-d2e8-757f-a66b-3077210ce38e",
    "storage_key": "property/6767906449167513/019ef53f-d2e8-757f-a66b-3077210ce38e.webp",
    "width": 2000,
    "height": 2000
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#757B77",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3 Beds",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "781 - 1081",
  "property_sqft_min": "781",
  "property_sqft_max": "1081",
  "property_price_range": "875 - 1065",
  "property_price_min": "875",
  "property_price_max": "1065",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/Pre3PropertyManagement",
  "property_instagram_url": null,
  "property_twitter_url": "https://twitter.com/pre_three",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJg0jZSks-QogRU8s_rwGOvAg",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/colonial-gardens-apartments-newark-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Colonial Gardens",
  "property_home_romance_title": "Embrace Your Dream Lifestyle in Our Charming Apartment Community",
  "property_home_amenities_blurb": "At Colonial Gardens in Georgetown, KY, your ideal living space awaits. Choose from stylish two and three-bedroom layouts, complete with in-unit laundry, private entrances, and air conditioning. Enjoy the convenience of off-street parking while unwinding on your private patio or balcony. Experience comfort and style redefined.",
  "property_home_floorplans_blurb": "At Colonial Gardens in Georgetown, KY, your ideal living space awaits. Choose from our stylish two and three-bedroom floor plans designed for comfort and convenience. Each apartment complements your lifestyle, offering ample space to unwind. Browse our available homes today and elevate your everyday living experience!",
  "property_home_gallery_blurb": "At Colonial Gardens in Georgetown, KY, comfort meets style in our thoughtfully designed apartments. Enjoy modern amenities like air conditioning, a deluxe appliance package, and private patios to unwind. With off-street parking and in-unit laundry, your perfect living space awaits. Picture yourself living here—experience home redefined!",
  "property_home_neighborhood_blurb": "At Colonial Gardens in Georgetown, KY, life thrives amid education and recreation. Just moments from Georgetown College, the Alltech Arena, and serene parks, our community is your gateway to vibrant local culture and essential services. Experience a blend of comfort and convenience in our spacious two- and three-bedroom floor plans! ",
  "property_home_reviews_blurb": "At Colonial Gardens in Georgetown, KY, our residents rave about the community vibe, stating, \"It truly feels like home here!\" With lush greenery and friendly neighbors, this is more than just an apartment—it’s a vibrant lifestyle. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Colonial Gardens in Georgetown, KY, vibrant living meets convenient access to local gems. Enjoy nearby cultural treasures like the Scott County Public Library and Bluegrass Community and Technical College, or relax at Great Crossing Park. Uncover the unique character of our neighborhood, perfectly complementing your two- or three-bedroom home.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Colonial Gardens in Georgetown, KY, your comfort takes center stage. Choose from thoughtfully designed two- and three-bedroom apartments featuring deluxe appliances, private patios, and modern conveniences like in-unit laundry. With off-street parking and select fully remodeled units, your perfect home awaits. Embrace a lifestyle of ease and elegance!",
  "property_applynow_blurb": "At Colonial Gardens in charming Georgetown, KY, our thoughtfully designed two and three-bedroom apartments offer modern living with essential amenities. Enjoy off-street parking, in-unit laundry, and private patios that elevate your lifestyle. With select units fully remodeled, your dream home awaits. Apply online today to make it yours!",
  "property_contactus_blurb": "At Colonial Gardens in Georgetown, KY, find your perfect home among our thoughtfully designed floor plans, featuring spacious two and three-bedroom options. Experience a vibrant community and modern amenities tailored to your lifestyle. Have questions? Contact our leasing team today to learn more about making Colonial Gardens your new home!",
  "property_faqs_blurb": "At Colonial Gardens in Georgetown, KY, we offer spacious two and three-bedroom floor plans tailored for modern living. Ready to have your queries answered? Our FAQs page is your go-to resource for everything you need to know about our vibrant community and lifestyle options. Dive in today!",
  "property_floorplans_blurb": "At Colonial Gardens in Georgetown, KY, we offer thoughtfully designed two and three-bedroom floor plans that cater to your lifestyle needs. Each layout combines comfort and functionality, ensuring a welcoming retreat. Browse our available apartment homes today and discover the perfect space for you and your loved ones.",
  "property_gallery_blurb": "At Colonial Gardens in Georgetown, KY, each spacious floor plan—whether two or three bedrooms—invites you to a lifestyle of comfort and convenience. Imagine savoring the sunset from your private balcony or enjoying modern amenities like in-unit laundry and deluxe appliances. Picture yourself living here! Check out our photo gallery.",
  "property_interactivemap_blurb": "At Colonial Gardens in Georgetown, KY, choose from spacious two and three-bedroom layouts, each designed for comfort and convenience. Enjoy off-street parking, private entrances, and delightful outdoor spaces. Dive into our interactive community map to find your perfect home today and experience the lifestyle you deserve!",
  "property_pets_blurb": "At Colonial Gardens in Georgetown, KY, your feline friends will thrive in our welcoming community. With a maximum of two playful cats per unit, let your pets enjoy their own space while you relish luxurious living. Embrace comfort, style, and a pet-friendly atmosphere at Colonial Gardens!",
  "property_referafriend_blurb": "At Colonial Gardens in Georgetown, KY, your dream apartment awaits! Choose from our spacious two or three-bedroom floor plans, perfect for relaxing and entertaining. Great friends make great neighbors—refer a friend to join our vibrant community today and create lasting memories together in your new home!",
  "property_residentaccess_blurb": "At Colonial Gardens in Georgetown, KY, our spacious two- and three-bedroom floor plans are designed for comfort and convenience. Whether you're settling in or seeking assistance, access your resident portal to effortlessly pay rent, schedule maintenance, and enjoy the little things that make life delightful. ",
  "property_reviews_blurb": "At Colonial Gardens in Georgetown, KY, residents rave about the welcoming atmosphere and beautiful grounds. One resident notes, “It's like a hidden gem; the community feels like home.” See what our residents have to say about living at our community! Your ideal lifestyle awaits at Colonial Gardens.",
  "property_created_at": "1779305731853",
  "property_scheduletour_blurb": "At Colonial Gardens in Georgetown, KY, our thoughtfully designed two and three-bedroom floor plans offer the perfect blend of comfort and style. Schedule a tour today to experience our vibrant community and hear firsthand from our residents about why they love calling Colonial Gardens home!",
  "property_thankyou_blurb": "Thank you for reaching out to Colonial Gardens in beautiful Georgetown, KY! With spacious two and three-bedroom floor plans designed for comfort and style, your ideal apartment awaits. Our team will be in touch shortly to help you embark on your journey to a new home. Stay tuned!",
  "property_virtualtours_blurb": "Experience the charm of Colonial Gardens in Georgetown, KY, where spacious two and three-bedroom apartments blend comfort with style. Each floor plan is designed to enhance your lifestyle. Take a virtual tour today and envision your next home in our inviting community!",
  "property_copyright": "2026 All Rights Reserved. Colonial Gardens",
  "property_seo_title_home": "Affordable Apartments in Georgetown, KY | Colonial Gardens",
  "property_seo_description_home": "Explore affordable apartments in Georgetown, KY at Colonial Gardens. Income restrictions apply. View 2 & 3 bedroom apartments and qualification details.",
  "property_seo_title_floorplans": "Affordable Apartments Georgetown, KY | Floor Plans",
  "property_seo_description_floorplans": "View affordable 2 & 3 bedroom apartments in Georgetown, KY at Colonial Gardens. Income restrictions apply. Explore floor plans and availability.",
  "property_seo_title_amenities": "Amenities | Georgetown, KY Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Colonial Gardens in Georgetown, KY—deluxe apartments with private patios and modern amenities. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Georgetown, KY",
  "property_seo_description_gallery": "Discover Colonial Gardens in Georgetown, KY! Enjoy spacious two- and three-bedroom homes with private patios and modern amenities in a welcoming community.",
  "property_seo_title_virtualtours": "Virtual Tours | Colonial Gardens Apartments",
  "property_seo_description_virtualtours": "Experience Colonial Gardens in Georgetown, KY! Take a virtual tour of our spacious two and three-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Colonial Gardens Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Colonial Gardens in Georgetown, KY! Use our interactive map to browse floor plans, explore amenities, and check pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Georgetown, KY",
  "property_seo_description_neighborhood": "Uncover Georgetown's charm at Colonial Gardens. Enjoy spacious two and three-bedroom apartments while discovering local favorites and hidden gems nearby!",
  "property_seo_title_contact": "Contact Us | Colonial Gardens",
  "property_seo_description_contact": "Explore Colonial Gardens in Georgetown, KY! Inquire about our spacious 2 & 3-bedroom plans and connect with our friendly leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Georgetown, KY",
  "property_seo_description_faqs": "Get the answers you need about Colonial Gardens in Georgetown, KY! Dive into our FAQs for insights on amenities, floor plans, and living your best life here.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Georgetown, KY",
  "property_seo_description_reviews": "Discover Colonial Gardens in Georgetown, KY! Read resident reviews and explore our two and three-bedroom homes with top-notch amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Georgetown, KY",
  "property_seo_description_applynow": "Discover comfort at Colonial Gardens, Georgetown, KY. Spacious 2 & 3-bedroom apartments with modern amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Colonial Gardens",
  "property_seo_description_residentaccess": "Log in to Colonial Gardens' resident portal for easy rent payments, maintenance requests, and community updates. Your comfort in Georgetown, KY, starts here!",
  "property_seo_title_referafriend": "Refer A Friend | Colonial Gardens",
  "property_seo_description_referafriend": "Refer a friend to Colonial Gardens in Georgetown, KY! Build a vibrant community where great friends become great neighbors. Share the joy today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Colonial Gardens",
  "property_seo_description_scheduletour": "Step into your future at Colonial Gardens in Georgetown, KY. Schedule your tour today and experience the charm and comfort of your new home!",
  "property_seo_title_privacy": "Privacy Policy | Colonial Gardens",
  "property_seo_description_privacy": "Experience peace of mind at Colonial Gardens. Your privacy matters—review our policy to learn how we protect your information in beautiful Georgetown, KY.",
  "property_seo_title_accessibility": "Website Accessibility | Colonial Gardens",
  "property_seo_description_accessibility": "Colonial Gardens in Georgetown, KY, champions digital inclusion. Our Accessibility Statement ensures everyone can experience comfort and community. Join us!",
  "property_seo_title_sitemap": "Sitemap | Colonial Gardens",
  "property_seo_description_sitemap": "Uncover the endless possibilities at Colonial Gardens in Georgetown, KY. Navigate our sitemap to easily find your future home and all we have to offer!",
  "property_seo_title_thankyou": "Thank You | Colonial Gardens",
  "property_seo_description_thankyou": "Thank you for reaching out to Colonial Gardens in Georgetown, KY! We’ll connect soon to help you find your perfect home. Exciting days ahead!",
  "property_seo_title_pets": "Pet Policy | Apartments in Georgetown, KY",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790198627136",
  "amenities": [
    {
      "id": "ec_5c082609b5f81a5c5250eb06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c9b0c4631cd7b1a3860d5d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab253c9f693e8bb01b9023e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae288b8cfc6cbe8231edb364",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f657e565a031c041bb7fcec5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d93418d34531d51569576ee8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Beautiful Residential Neighborhood",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c649f7797824cb0c6bb39ba7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1be6d57cab939511aaef397b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f86215f139ee3d5d3bfe785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a67bea85b6c5d2bdea57d6fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Huge Closets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24e265a84761a2467656ecfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Off Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_263e846b59ad12cd53f27e11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e313a471d36659081744ba19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Entrances",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_411f3db9e61f8f0cff190e31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Stove/Oven",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0be582d511ccab59111990b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Tons Of Cabinet Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26774e45d25e9a394f7b9231",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42aa5de63885c740fe5fc940",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7eb3b1668d2d65a27453eba9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_889dcb7626bbaf5eefd82544",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e53a091133d7f4512711f03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_385fcbb674f655c1282687bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec33f2dee38ee9f327276053",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_375910e07cd645272b99be3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2629922be8e6a428e93f6f95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e6061fbd7e6123b605381a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43739807ac26214dfcdf687d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91ed01ebe2e518ecb0822631",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efa459ca9f696f4f7d9b772b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37f5c95dd4d25f4c65aa763b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffd115f9f4d9c0c79cd35ace",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21e9b9c21f4e62a61573f5a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_227032b02cfe01b9afcde72a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73e37d0f848afc3acaed1ade",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75521473af107f75242471c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_dc5be332-4b05-4bdb-9624-548017a635f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019f054a-41bd-74c5-a488-fb97920104d5.webp",
      "image_media": {
        "alt_text": "Couple enjoying a meal together in a kitchen.",
        "public_id": "019f054a-41bd-74c5-a488-fb97920104d5",
        "storage_key": "property/6767906449167513/019f054a-41bd-74c5-a488-fb97920104d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A happy couple shares a meal at their kitchen table, highlighting the comfort and convenience of home dining.",
      "link": "",
      "alt_text": "Couple enjoying a meal together in a kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb51082e-0c22-4617-bee6-7d4baa0b4ab3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e8f24-636f-7189-a657-a55af175c76c.webp",
      "image_media": {
        "alt_text": "Exterior view of brick and siding apartment building with parking lot.",
        "public_id": "019e8f24-636f-7189-a657-a55af175c76c",
        "storage_key": "property/6767906449167513/019e8f24-636f-7189-a657-a55af175c76c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing its brick and siding facade, private balconies, and convenient parking area.",
      "link": "",
      "alt_text": "Exterior view of brick and siding apartment building with parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2da9255c-e022-4050-b980-28cf50d9adf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019f054a-6a3f-7588-8061-96e887417457.webp",
      "image_media": {
        "alt_text": "Father holding his son up in the air, both laughing.",
        "public_id": "019f054a-6a3f-7588-8061-96e887417457",
        "storage_key": "property/6767906449167513/019f054a-6a3f-7588-8061-96e887417457.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "A father and son sharing a joyful moment at home, highlighting the warm and happy atmosphere.",
      "link": "",
      "alt_text": "Father holding his son up in the air, both laughing.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75b1b796-9bce-4855-9176-29f56a9281cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e8f24-62d9-731d-a44b-243c04b34e83.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a vibrant red-leaved tree in front during autumn.",
        "public_id": "019e8f24-62d9-731d-a44b-243c04b34e83",
        "storage_key": "property/6767906449167513/019e8f24-62d9-731d-a44b-243c04b34e83.webp",
        "width": 2802,
        "height": 2304
      },
      "title": "Community",
      "description": "Charming apartment building exterior showcasing autumnal beauty with a bright red-leaved tree framing the brick and siding facade.",
      "link": "",
      "alt_text": "Apartment building exterior with a vibrant red-leaved tree in front during autumn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a44923a-f3d3-4ea8-b3e8-ec7db6152293",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019f054a-8481-75ad-9ac0-645a8bc74b9e.webp",
      "image_media": {
        "alt_text": "Man with beard and coffee cup smiling in a stylish apartment.",
        "public_id": "019f054a-8481-75ad-9ac0-645a8bc74b9e",
        "storage_key": "property/6767906449167513/019f054a-8481-75ad-9ac0-645a8bc74b9e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a moment of relaxation with a warm beverage in your beautifully appointed apartment.",
      "link": "",
      "alt_text": "Man with beard and coffee cup smiling in a stylish apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c15bef76-57cf-450f-8aa5-ae29b35547bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e8f24-6248-74ce-b7d9-8c1b09ddf6eb.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living room with a ceiling fan and sliding glass doors leading to a grassy yard.",
        "public_id": "019e8f24-6248-74ce-b7d9-8c1b09ddf6eb",
        "storage_key": "property/6767906449167513/019e8f24-6248-74ce-b7d9-8c1b09ddf6eb.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral carpeting and a ceiling fan, featuring sliding glass doors that open to a scenic outdoor space. Perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Interior view of an empty apartment living room with a ceiling fan and sliding glass doors leading to a grassy yard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a54d2c8-81b7-404d-b73c-e25d3a0901b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e8f24-6249-754f-98a5-847c899a52bb.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, and bathtub/shower.",
        "public_id": "019e8f24-6249-754f-98a5-847c899a52bb",
        "storage_key": "property/6767906449167513/019e8f24-6249-754f-98a5-847c899a52bb.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "View of a clean and functional bathroom, featuring a bathtub/shower combination, a toilet, and a vanity with sink.",
      "link": "",
      "alt_text": "Bathroom with toilet, sink, and bathtub/shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_62a23049-785f-4adb-8dd0-37c47adce203",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e8f24-5ef8-765c-86cb-cbabc1baf7bd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with parking lot and fire hydrant.",
        "public_id": "019e8f24-5ef8-765c-86cb-cbabc1baf7bd",
        "storage_key": "property/6767906449167513/019e8f24-5ef8-765c-86cb-cbabc1baf7bd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment building complex showcasing the architecture and surrounding grounds.",
      "link": "",
      "alt_text": "Exterior view of apartment building with parking lot and fire hydrant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd3b993b-c4f6-4c04-97a9-4e4955ef0b15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e8f24-6043-7759-8509-0a401297336f.webp",
      "image_media": {
        "alt_text": "Playground structure with slides, climbing wall, and swings.",
        "public_id": "019e8f24-6043-7759-8509-0a401297336f",
        "storage_key": "property/6767906449167513/019e8f24-6043-7759-8509-0a401297336f.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Community playground featuring a large wooden play structure with a tube slide, climbing wall, and swings. Perfect for resident families.",
      "link": "",
      "alt_text": "Playground structure with slides, climbing wall, and swings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4255e37-e057-430b-8ba3-371d2c65e44a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e8f24-4439-720e-9f8c-bda8b92c8e5f.webp",
      "image_media": {
        "alt_text": "Exterior building entrance with red brick, green shutters, and a green door.",
        "public_id": "019e8f24-4439-720e-9f8c-bda8b92c8e5f",
        "storage_key": "property/6767906449167513/019e8f24-4439-720e-9f8c-bda8b92c8e5f.webp",
        "width": 2010,
        "height": 1149
      },
      "title": "Community",
      "description": "An exterior shot showcasing the red brick building entrance with green shutters and door, surrounded by manicured landscaping and mature trees.",
      "link": "",
      "alt_text": "Exterior building entrance with red brick, green shutters, and a green door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_288158fa-9fa7-4337-9357-d779ae0633bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e8f24-43a2-72ff-ab48-41a822c36496.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and brick accents.",
        "public_id": "019e8f24-43a2-72ff-ab48-41a822c36496",
        "storage_key": "property/6767906449167513/019e8f24-43a2-72ff-ab48-41a822c36496.webp",
        "width": 1598,
        "height": 1361
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing the architecture and design of the complex.",
      "link": "",
      "alt_text": "Exterior view of apartment building with balconies and brick accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_22ad9afb-6622-4504-a3bc-00bd475bff40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019f054a-4a1e-7119-8b26-01094dc43021.webp",
      "image_media": {
        "alt_text": "Two happy women smiling and looking at a smartphone together in a bright apartment living room.",
        "public_id": "019f054a-4a1e-7119-8b26-01094dc43021",
        "storage_key": "property/6767906449167513/019f054a-4a1e-7119-8b26-01094dc43021.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "Enjoy memorable moments and connect with friends in our welcoming apartment homes, perfect for sharing laughs and good times.",
      "link": "",
      "alt_text": "Two happy women smiling and looking at a smartphone together in a bright apartment living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d6b4325a-5bb6-4ec5-a203-c40a56d8d764",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019f054a-8113-70ba-987a-d9273b0a7f9a.webp",
      "image_media": {
        "alt_text": "Two people walking a dog on a leash in a park.",
        "public_id": "019f054a-8113-70ba-987a-d9273b0a7f9a",
        "storage_key": "property/6767906449167513/019f054a-8113-70ba-987a-d9273b0a7f9a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a leisurely walk with your furry friend in our pet-friendly community's beautiful green spaces.",
      "link": "",
      "alt_text": "Two people walking a dog on a leash in a park.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7ac687c3-0a3d-4824-aae7-5ec4c164076b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Cattleman's Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "240 Champion Way, Georgetown, KY 40324, USA",
      "poi_short_description": "Down-home steakhouse featuring hand-cut meats, plus burgers & other American eats in a casual space.",
      "poi_long_description": "Diners say this restaurant serves up a delicious salad bar with fresh greens, potato salad, and bacon, alongside tasty steaks, chicken, and chops. They also highlight the friendly and attentive service, reasonable prices, and homey atmosphere.\n\nSome reviews mention the steak can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e26d-779c-a6f7-2f4820ef9be6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e26d-779c-a6f7-2f4820ef9be6",
        "storage_key": "property/6767906449167513/019e46e2-e26d-779c-a6f7-2f4820ef9be6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cattlemansroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3430448140062867588&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cattlemans-roadhouse",
      "poi_latitude": "38.22588229999999",
      "poi_longitude": "-84.54139909999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 502-642-4139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca1-7388-8444-94c13f0c4587",
        "storage_key": "property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY11YriI_QogRhMDYeGhmmy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_07176c6f-eeea-44cc-9259-df19a11f6f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "101 Tiger Way, Georgetown, KY 40324, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast-food restaurant offers delicious chicken, including chicken sandwiches and chicken minis, and that the food is consistently fresh and hot. They also highlight the fast and efficient service, with staff often going above and beyond. Guests mention the staff are well-trained, professional, and genuinely welcoming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e44c-7688-a91c-df99dd43faa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e44c-7688-a91c-df99dd43faa3",
        "storage_key": "property/6767906449167513/019e46e2-e44c-7688-a91c-df99dd43faa3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ky/georgetown-ky?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17280186891004281104&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "38.2222037",
      "poi_longitude": "-84.53913639999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 502-863-6767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca1-7388-8444-94c13f0c4587",
        "storage_key": "property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDekhTiM_QogREAGsSmyOz-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3111de36-14d7-401d-a9dd-4e969b0211fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1505 Paris Pike, Georgetown, KY 40324, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Guests consistently praise this restaurant for its delicious and well-cooked steaks, ribs, and grilled shrimp, complemented by generous portions and fresh rolls. The friendly atmosphere, excellent service, and reasonable prices further enhance the dining experience.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e705-71a4-a292-447bda2cd1d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e705-71a4-a292-447bda2cd1d6",
        "storage_key": "property/6767906449167513/019e46e2-e705-71a4-a292-447bda2cd1d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/kentucky/georgetown?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=6470537537903560490&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "38.2137861",
      "poi_longitude": "-84.54105140000001",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 502-735-0335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca1-7388-8444-94c13f0c4587",
        "storage_key": "property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsYNMaLE_QogRKoeSvJv3y1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_ee9d329e-a1d3-4b31-98e4-125848d133d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "102 Success Dr, Georgetown, KY 40324, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves moist and crispy chicken fingers. They also highlight the fast service, friendly staff, and clean environment.\n\nOther reviews mention the fries can be soggy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e6aa-7601-9527-095256c9740e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e6aa-7601-9527-095256c9740e",
        "storage_key": "property/6767906449167513/019e46e2-e6aa-7601-9527-095256c9740e.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ky/georgetown/102-success-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=18003014272444948027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "38.2201878",
      "poi_longitude": "-84.5416537",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 502-642-5763",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca1-7388-8444-94c13f0c4587",
        "storage_key": "property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQSSFT0_QogRO15ewxiO1_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_6a471c91-1f0f-4a6b-a216-a3660b7fede0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Local Feed",
      "poi_type": "Restaurants",
      "poi_address": "214 S Water St, Georgetown, KY 40324, USA",
      "poi_short_description": "Local comfort fare & bourbon cocktails in a historic, exposed brick building with patio seating.",
      "poi_long_description": "Diners praise this restaurant's delicious farm-to-table food, including wagyu meatloaf, fried chicken, and deviled eggs, which come in generous portions alongside a diverse menu. They also appreciate the friendly staff, cool atmosphere, and reasonable prices.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e247-738b-992e-6e1de38e36be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e247-738b-992e-6e1de38e36be",
        "storage_key": "property/6767906449167513/019e46e2-e247-738b-992e-6e1de38e36be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.localfeedky.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9685492844241373472&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "local-feed",
      "poi_latitude": "38.2082042",
      "poi_longitude": "-84.5615766",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 502-642-8998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca1-7388-8444-94c13f0c4587",
        "storage_key": "property/6767906449167513/019e46e3-0ca1-7388-8444-94c13f0c4587.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wp5zHU_QogRIEmYB23IaYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_cfedc7eb-5c24-457b-aef6-2d51d435de7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "106 Marketplace Cir, Georgetown, KY 40324, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Customers consistently praise this grocery store for its better quality products, greater product variety with a well-stocked selection, and better prescription options at the pharmacy. The convenient shopping experience further enhances its appeal.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e1c0-736b-b39d-6fcbf9b1d918.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e1c0-736b-b39d-6fcbf9b1d918",
        "storage_key": "property/6767906449167513/019e46e2-e1c0-736b-b39d-6fcbf9b1d918.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ky/georgetown/marketplace-circle/024/00779?cid=loc_02400779_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1823161534221965504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "38.186348",
      "poi_longitude": "-84.5683529",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 502-863-4807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0cae-72f8-b3c2-540ebdff71b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0cae-72f8-b3c2-540ebdff71b7",
        "storage_key": "property/6767906449167513/019e46e3-0cae-72f8-b3c2-540ebdff71b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxD9OYBAQogRwNh0f8ErTRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e896a3ba-302d-4d54-b45f-893e744125fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "109 Magnolia Dr, Georgetown, KY 40324, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers fast and helpful service, with employees who are friendly and efficient. They also highlight the easy accessibility and convenient online order pickup.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e1c1-71d2-b168-24c59fba5c94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e1c1-71d2-b168-24c59fba5c94",
        "storage_key": "property/6767906449167513/019e46e2-e1c1-71d2-b168-24c59fba5c94.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/KY-Georgetown/1736?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1736-_-na-_-0-_-0&y_source=1_MTE4MzQxOC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15169823916353113434&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "38.228142",
      "poi_longitude": "-84.534769",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 502-570-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ceb-7777-b1f5-b7f6bf19d292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ceb-7777-b1f5-b7f6bf19d292",
        "storage_key": "property/6767906449167513/019e46e3-0ceb-7777-b1f5-b7f6bf19d292.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwZphWyY_QogRWs1zj3oKhtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_563f3f8f-cbec-476a-84bd-3a4bf41f24d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Georgetown Peddlers Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "401 Outlet Center Dr #270, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this antique store offers a wide variety of unique household items, furniture, and odds and ends. They also highlight the clean and organized booths, the friendly and helpful staff, and the down-home atmosphere.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e6aa-7601-9527-04de7c92f29c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e6aa-7601-9527-04de7c92f29c",
        "storage_key": "property/6767906449167513/019e46e2-e6aa-7601-9527-04de7c92f29c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://buypeddlersmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3575055177454669358&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgetown-peddlers-mall",
      "poi_latitude": "38.2178497",
      "poi_longitude": "-84.5374374",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 502-868-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ceb-7777-b1f5-b7f6bf19d292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ceb-7777-b1f5-b7f6bf19d292",
        "storage_key": "property/6767906449167513/019e46e3-0ceb-7777-b1f5-b7f6bf19d292.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJj7eWkDw_QogRLk6bEL4lnTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_2577cf6d-f477-496f-bf11-7c6abceab2fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "135 American Path, Georgetown, KY 40324, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this grocery store offers a wide selection of high-quality items, including organic produce, and unique non-grocery products. They also highlight the great prices and cost-effectiveness, making it a good alternative to other stores. Visitors appreciate the clean, well-stocked, and organized store, as well as the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e301-76da-a662-37646f318d77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e301-76da-a662-37646f318d77",
        "storage_key": "property/6767906449167513/019e46e2-e301-76da-a662-37646f318d77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ky/georgetown/135-american-path/fe57",
      "poi_directions_map_url": "https://maps.google.com/?cid=15168555622251780597&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.183564",
      "poi_longitude": "-84.56183399999999",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0cae-72f8-b3c2-540ebdff71b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0cae-72f8-b3c2-540ebdff71b7",
        "storage_key": "property/6767906449167513/019e46e3-0cae-72f8-b3c2-540ebdff71b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzrvy-9BQogR9VkS1PiIgdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8fcdcc8d-6701-4a8d-9b42-5b03993045eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Georgetown Antique Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "124 W Main St, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-e9b6-750c-8a97-89ff67cf3a9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-e9b6-750c-8a97-89ff67cf3a9c",
        "storage_key": "property/6767906449167513/019e46e2-e9b6-750c-8a97-89ff67cf3a9c.webp",
        "width": 1270,
        "height": 714
      },
      "poi_business_url": "https://www.facebook.com/125706704149397/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8293034744925865912&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgetown-antique-mall",
      "poi_latitude": "38.2097365",
      "poi_longitude": "-84.5604427",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 502-863-1891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ceb-7777-b1f5-b7f6bf19d292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ceb-7777-b1f5-b7f6bf19d292",
        "storage_key": "property/6767906449167513/019e46e3-0ceb-7777-b1f5-b7f6bf19d292.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsSTA8nQ_QogRuEdHgSnHFnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_527462cd-c18d-4d7d-b4e3-f729540c676a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Georgetown College",
      "poi_type": "Education",
      "poi_address": "400 E College St, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-eae3-72ce-a0e6-b769287a8eaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-eae3-72ce-a0e6-b769287a8eaf",
        "storage_key": "property/6767906449167513/019e46e2-eae3-72ce-a0e6-b769287a8eaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.georgetowncollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14171004933067459627&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgetown-college",
      "poi_latitude": "38.2070039",
      "poi_longitude": "-84.5542847",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 502-863-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0cea-70ee-a791-5a362ff859be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0cea-70ee-a791-5a362ff859be",
        "storage_key": "property/6767906449167513/019e46e3-0cea-70ee-a791-5a362ff859be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-YvsbXI_QogRK0zLyeeFqcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c52a297b-859f-4e2f-a35a-c8017e284e93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Scott County Public Library",
      "poi_type": "Education",
      "poi_address": "104 S Bradford Ln, Georgetown, KY 40324, USA",
      "poi_short_description": "Kids' space with books plus free things to do and quiet rooms for reading or working.",
      "poi_long_description": "People say this library offers a huge selection of materials, a wide variety of activities, and excellent children's programs. They also highlight the clean, peaceful facility and the helpful, friendly staff. Guests mention the convenient bookmobile service and free internet access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-ec12-756f-87ce-db523187c2f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-ec12-756f-87ce-db523187c2f2",
        "storage_key": "property/6767906449167513/019e46e2-ec12-756f-87ce-db523187c2f2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.scottpublib.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13613495873871186732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scott-county-public-library",
      "poi_latitude": "38.1912866",
      "poi_longitude": "-84.56411659999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 502-863-3566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0cea-70ee-a791-5a362ff859be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0cea-70ee-a791-5a362ff859be",
        "storage_key": "property/6767906449167513/019e46e3-0cea-70ee-a791-5a362ff859be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj1PG7n8_QogRLItWsV7a7Lw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e846dd18-f60d-41f8-aa91-ef7d47c35a18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Bluegrass Community and Technical College - Georgetown-Scott County Campus",
      "poi_type": "Education",
      "poi_address": "200 Technology Ct, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-ecde-747a-836d-da8b96abf1a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-ecde-747a-836d-da8b96abf1a7",
        "storage_key": "property/6767906449167513/019e46e2-ecde-747a-836d-da8b96abf1a7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bluegrass.kctcs.edu/about/campuses/georgetown/index.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11013568345693242972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluegrass-community-and-technical-college---georgetown-scott-county-campus",
      "poi_latitude": "38.2688293",
      "poi_longitude": "-84.5086898",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 502-570-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0cea-70ee-a791-5a362ff859be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0cea-70ee-a791-5a362ff859be",
        "storage_key": "property/6767906449167513/019e46e3-0cea-70ee-a791-5a362ff859be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFwHx4Vk5QogRXEaI2g4O2Jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ab07ed24-9ece-40a2-91f8-2c21c5c88c64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Alltech Arena",
      "poi_type": "Entertainment",
      "poi_address": "4089 Iron Works Pkwy, Lexington, KY 40511, USA",
      "poi_short_description": "Clean, climate-controlled arena, as well as seating and parking for horses and spectators.",
      "poi_long_description": "Visitors say this arena hosts exciting horse events, including Road to the Horse and the Liberty Festival, and they praise the ample parking. They also highlight the relaxed atmosphere, making it a great place to enjoy horse shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-ef37-7289-a467-25f1caadfe59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-ef37-7289-a467-25f1caadfe59",
        "storage_key": "property/6767906449167513/019e46e2-ef37-7289-a467-25f1caadfe59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kyhorsepark.com/venue/alltech-arena/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7696774640541491227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alltech-arena",
      "poi_latitude": "38.1581532",
      "poi_longitude": "-84.5236688",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 859-233-4303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQyVJ9ytHQogRG-C1ncFv0Go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_c16c276b-8d51-4b8c-b70d-b46c81ab817c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Suffoletta Family Aquatic Center",
      "poi_type": "Entertainment",
      "poi_address": "200 Jacobs Dr, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0253-733f-8317-77d40c81fa57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-0253-733f-8317-77d40c81fa57",
        "storage_key": "property/6767906449167513/019e46e3-0253-733f-8317-77d40c81fa57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gscparks.com/facilities/suffoletta-family-aquatic-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1463265895495966093&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "suffoletta-family-aquatic-center",
      "poi_latitude": "38.186294",
      "poi_longitude": "-84.56581229999999",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 502-868-8009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3289n5AQogRjR37SJSQThQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_20da83a4-638a-4133-a771-f4cc1dd9a055",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Toyota Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Georgetown, KY 40324, USA",
      "poi_short_description": "Stadium for Georgetown College's sports games, including football and lacrosse events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-ef3d-72ac-98a9-db26d2d24c69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-ef3d-72ac-98a9-db26d2d24c69",
        "storage_key": "property/6767906449167513/019e46e2-ef3d-72ac-98a9-db26d2d24c69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5641347597943218565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "toyota-stadium",
      "poi_latitude": "38.2045914",
      "poi_longitude": "-84.5444693",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ceb-7777-b1f5-b0103a6c1ec1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ceb-7777-b1f5-b0103a6c1ec1",
        "storage_key": "property/6767906449167513/019e46e3-0ceb-7777-b1f5-b0103a6c1ec1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJySWy6mk_QogRhaHoTcAXSk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_b39a4369-faff-419d-9cac-116b49e94a84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Toyota Kentucky Experience Center",
      "poi_type": "Entertainment",
      "poi_address": "1001 Cherry Blossom Way, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-f0ad-77ad-b3eb-8dbda6f82e8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-f0ad-77ad-b3eb-8dbda6f82e8d",
        "storage_key": "property/6767906449167513/019e46e2-f0ad-77ad-b3eb-8dbda6f82e8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6616848697865564819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "toyota-kentucky-experience-center",
      "poi_latitude": "38.2608429",
      "poi_longitude": "-84.5313326",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 502-570-6572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ce0-775a-9232-5de6d7f2aceb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ce0-775a-9232-5de6d7f2aceb",
        "storage_key": "property/6767906449167513/019e46e3-0ce0-775a-9232-5de6d7f2aceb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRcGGIAA_QogRk3LISNXE01s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ad4910cf-dd91-4320-b593-f9151163caca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Ward Hall",
      "poi_type": "Entertainment",
      "poi_address": "1782 Frankfort Pike, Georgetown, KY 40324, USA",
      "poi_short_description": "Stately Greek Revival mansion from the 1850s, with docent-led tours through its period interiors.",
      "poi_long_description": "Stately Greek Revival mansion from the 1850s, with docent-led tours through its period interiors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-efef-712a-9a95-44c0bf69bde3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-efef-712a-9a95-44c0bf69bde3",
        "storage_key": "property/6767906449167513/019e46e2-efef-712a-9a95-44c0bf69bde3.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://www.wardhall.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2903356207491866671&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ward-hall",
      "poi_latitude": "38.2072452",
      "poi_longitude": "-84.5890266",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 502-370-6621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ce0-775a-9232-5de6d7f2aceb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ce0-775a-9232-5de6d7f2aceb",
        "storage_key": "property/6767906449167513/019e46e3-0ce0-775a-9232-5de6d7f2aceb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJreYwQuw_QogRL2D6ixbLSig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_29f1180a-45b2-48fe-b5e8-46fd2f39bb87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "101 Fitness Path, Georgetown, KY 40324, USA",
      "poi_short_description": "Chain gym featuring clean fitness areas plus stand-up and lie-down tanning booths and hydro-massage beds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-f4c0-738a-afc1-9356a2b4b3c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-f4c0-738a-afc1-9356a2b4b3c1",
        "storage_key": "property/6767906449167513/019e46e2-f4c0-738a-afc1-9356a2b4b3c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/georgetown-ky?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8175512701348918023&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.23259729999999",
      "poi_longitude": "-84.5316692",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 502-316-6325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPagcOA8_QogRB7OYdHxBdXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_449d9380-ccf1-47fe-aae4-e0d542ca8161",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "TMMKFitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1001 Cherry Blossom Way, Georgetown, KY 40324, USA",
      "poi_short_description": "Clean gym focusing on group fitness classes and equipment training with friendly staff and trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-f572-736d-ad16-ffaa2834180d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-f572-736d-ad16-ffaa2834180d",
        "storage_key": "property/6767906449167513/019e46e2-f572-736d-ad16-ffaa2834180d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tmmkfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16039424024525663911&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tmmkfitness",
      "poi_latitude": "38.2457984",
      "poi_longitude": "-84.54021379999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 502-868-3820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7i4ssM-QogRp-63dyt7l94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d1eae7b0-08e5-4845-b249-fb18d90bd21d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Central Kentucky Veterinary Center",
      "poi_type": "Health and Wellness",
      "poi_address": "111 Southgate Dr, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-f505-730a-ba3b-7383338783ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-f505-730a-ba3b-7383338783ef",
        "storage_key": "property/6767906449167513/019e46e2-f505-730a-ba3b-7383338783ef.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://centralkentuckyvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9918112931439337952&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-kentucky-veterinary-center",
      "poi_latitude": "38.1828628",
      "poi_longitude": "-84.5595427",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 502-863-0868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ZA8KIBAQogR4GGmqCk3pIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_1d0e90aa-a7d1-432d-b6ca-5d00e1f89aa0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Bliss Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Ikebana Path Suite B, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-f88a-74dc-ad40-1d22d1182b56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-f88a-74dc-ad40-1d22d1182b56",
        "storage_key": "property/6767906449167513/019e46e2-f88a-74dc-ad40-1d22d1182b56.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.blissnailsky.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2229471176976718056&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bliss-nails",
      "poi_latitude": "38.23041389999999",
      "poi_longitude": "-84.5327018",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 502-370-4693",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7683i9w_QogR6FirJDms8B4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_a5dce6a5-130c-4af1-aef1-fc94543cb932",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "A List Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "126 Amerson Way D, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-fc89-75da-acbb-79a1df655416.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-fc89-75da-acbb-79a1df655416",
        "storage_key": "property/6767906449167513/019e46e2-fc89-75da-acbb-79a1df655416.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://phorest.com/book/salons/alistsalon",
      "poi_directions_map_url": "https://maps.google.com/?cid=885345275107888015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "a-list-salon",
      "poi_latitude": "38.1900105",
      "poi_longitude": "-84.5409521",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 502-603-8212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwQZPqs_QogRj0tgQtZgSQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_72f5d378-960f-4d93-8a27-d462ba7d283e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "111 Osborne Way Ste 2, Georgetown, KY 40324, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-f881-7328-8082-8fbe9bd530b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-f881-7328-8082-8fbe9bd530b0",
        "storage_key": "property/6767906449167513/019e46e2-f881-7328-8082-8fbe9bd530b0.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ky/georgetown/111-osbourne-way?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16127868823735272916&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "38.23208080000001",
      "poi_longitude": "-84.5377664",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 502-867-0737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSoAFyc_QogR1IXW_j6z0d8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_627b3a29-9e03-491c-b288-f18a8376fde5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Best Pets Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "529 E Washington St, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-f8a8-763c-823d-ccdfe9ac1b59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-f8a8-763c-823d-ccdfe9ac1b59",
        "storage_key": "property/6767906449167513/019e46e2-f8a8-763c-823d-ccdfe9ac1b59.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.thebestpets.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14234928142993941089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "best-pets-animal-clinic",
      "poi_latitude": "38.2111929",
      "poi_longitude": "-84.5501675",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 502-867-0740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYkILiQ_QogRYWJd5rmfjMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ce3fe28a-a4d0-4d79-9c01-6b0b35e69530",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Scott County Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2099 Frankfort Pike, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-fa0d-7719-a4ba-81294b9e5f63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-fa0d-7719-a4ba-81294b9e5f63",
        "storage_key": "property/6767906449167513/019e46e2-fa0d-7719-a4ba-81294b9e5f63.webp",
        "width": 1280,
        "height": 913
      },
      "poi_business_url": "https://scottcountyvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14374197462630248726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scott-county-veterinary-clinic",
      "poi_latitude": "38.2115717",
      "poi_longitude": "-84.60548779999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 502-863-5548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJidmcdF8VQogRFrFlO29oe8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_c4ca725f-9346-41ca-aa61-3dce5fe364fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "All 4 Paws Inc",
      "poi_type": "Health and Wellness",
      "poi_address": "102 Finley Dr #108, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-fa8f-71d3-b82e-c1e810389939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-fa8f-71d3-b82e-c1e810389939",
        "storage_key": "property/6767906449167513/019e46e2-fa8f-71d3-b82e-c1e810389939.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://all4pawsinc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13224244717948360030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "all-4-paws-inc",
      "poi_latitude": "38.2126235",
      "poi_longitude": "-84.538208",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 502-370-4086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3zvmJD8_QogRXtUlhIH0hbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_cd821d1b-6553-48a0-b7d8-769524fd9a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Bluegrass Orthopaedics",
      "poi_type": "Health and Wellness",
      "poi_address": "101 Windsor Path, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-ff93-747d-ab32-bbe227c104d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-ff93-747d-ab32-bbe227c104d8",
        "storage_key": "property/6767906449167513/019e46e2-ff93-747d-ab32-bbe227c104d8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bluegrassortho.com/locations/georgetown-office/?utm_source=GMBSocialClimb&utm_medium=BluegrassOrthopaedics",
      "poi_directions_map_url": "https://maps.google.com/?cid=10644398600433677445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluegrass-orthopaedics",
      "poi_latitude": "38.1847016",
      "poi_longitude": "-84.55766129999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 859-577-9276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0cdd-70c9-b0a9-0ad047d58551.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0cdd-70c9-b0a9-0ad047d58551",
        "storage_key": "property/6767906449167513/019e46e3-0cdd-70c9-b0a9-0ad047d58551.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWwbDYRAQogRhbSDciGAuJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_5088f2ed-bc4e-4aec-a38c-f0af51a21d47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "UK HealthCare Georgetown",
      "poi_type": "Health and Wellness",
      "poi_address": "202 Bevins Ln, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-fb13-7438-a2dc-6b64d0149e54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-fb13-7438-a2dc-6b64d0149e54",
        "storage_key": "property/6767906449167513/019e46e2-fb13-7438-a2dc-6b64d0149e54.webp",
        "width": 965,
        "height": 603
      },
      "poi_business_url": "https://ukhealthcare.uky.edu/hospitals-clinics/georgetown?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10482132882597654908&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uk-healthcare-georgetown",
      "poi_latitude": "38.18085749999999",
      "poi_longitude": "-84.56778969999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 859-323-9333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0cdd-70c9-b0a9-0ad047d58551.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0cdd-70c9-b0a9-0ad047d58551",
        "storage_key": "property/6767906449167513/019e46e3-0cdd-70c9-b0a9-0ad047d58551.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96hKkXxAQogRfLGs61EEeJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fb24a84d-7775-43f8-9ce8-e47cb216ecac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Cherry Blossom Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "150 Clubhouse Dr, Georgetown, KY 40324, USA",
      "poi_short_description": "Public 18-hole golf course with a clubhouse restaurant offering military discounts.",
      "poi_long_description": "Reviewers consistently praise this golf course for its beautiful views, fun and challenging design, and excellent greens. Guests also appreciate the delicious food, reasonable prices, and the friendly, helpful staff.\n\nSome reviews mention the course conditions can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-fc6c-7684-a3b5-c6db69583698.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-fc6c-7684-a3b5-c6db69583698",
        "storage_key": "property/6767906449167513/019e46e2-fc6c-7684-a3b5-c6db69583698.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cherryblossom.golf/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15150394045435030323&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cherry-blossom-golf-club",
      "poi_latitude": "38.2342932",
      "poi_longitude": "-84.5258257",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 502-570-9849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca4-7318-b4dd-050a8663893a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca4-7318-b4dd-050a8663893a",
        "storage_key": "property/6767906449167513/019e46e3-0ca4-7318-b4dd-050a8663893a.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30M1cNM-QogRMytZNR0DQdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_66b3ae55-9916-4252-aab2-0a98b1130073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Scott County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1260 Scott County Park Rd, Georgetown, KY 40324, USA",
      "poi_short_description": "Recreation site on 67 acres with fields for basketball & soccer, plus picnic areas & walking trails.",
      "poi_long_description": "People say this park offers a nice paved walking trail around the lake, a frisbee golf course, and basketball courts. Visitors also highlight the well-maintained picnic areas and open spaces. They also mention the lake is stocked with channel catfish and rainbow trout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-fda1-77cc-91c0-f269993f6013.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-fda1-77cc-91c0-f269993f6013",
        "storage_key": "property/6767906449167513/019e46e2-fda1-77cc-91c0-f269993f6013.webp",
        "width": 1280,
        "height": 633
      },
      "poi_business_url": "http://www.gscparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12516179666551705353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scott-county-park",
      "poi_latitude": "38.240854",
      "poi_longitude": "-84.571359",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 502-863-7865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1630b55f1990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1630b55f1990",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1630b55f1990.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPX4EVVA-QogRCQ_I2Rdnsq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2f2450f2-ed0d-43c3-b555-0a3f423d16ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Longview Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3243 Frankfort Pike, Georgetown, KY 40324, USA",
      "poi_short_description": "Golf course offering a clubhouse & driving range, plus low-key, 2-bedroom apartments with kitchens.",
      "poi_long_description": "People say this golf course offers a challenging layout and has seen positive improvements with a newly installed sprinkler system. They also highlight the reasonable prices, cheerful staff, and nice golf carts.\n\nSome reviews mention the course can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-076b-72ff-8e5b-f97cf932e22a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-076b-72ff-8e5b-f97cf932e22a",
        "storage_key": "property/6767906449167513/019e46e3-076b-72ff-8e5b-f97cf932e22a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.longviewgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8861543157144909737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "longview-golf-course",
      "poi_latitude": "38.21249880000001",
      "poi_longitude": "-84.65968219999999",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 502-863-2165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca4-7318-b4dd-050a8663893a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca4-7318-b4dd-050a8663893a",
        "storage_key": "property/6767906449167513/019e46e3-0ca4-7318-b4dd-050a8663893a.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6BSndwUQogRqXdqC42G-no",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_c72e04e3-cffc-4ce6-ab5c-11f67f340fc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Great Crossing Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "135 Betsy Wy, Georgetown, KY 40324, USA",
      "poi_short_description": "Park with baseball fields and a children's playground, plus picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-ff45-7387-bf1c-c1363540b62e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-ff45-7387-bf1c-c1363540b62e",
        "storage_key": "property/6767906449167513/019e46e2-ff45-7387-bf1c-c1363540b62e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gscparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8473078184464020794&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-crossing-park",
      "poi_latitude": "38.21713829999999",
      "poi_longitude": "-84.59982819999999",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 502-863-7865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1630b55f1990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1630b55f1990",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1630b55f1990.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfX98Aw_QogROvUWa7drlnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0682d883-5614-4915-b627-2fe2c5b53de2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Yuko-En on the Elkhorn",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 US-25, Georgetown, KY 40324, USA",
      "poi_short_description": "This friendship symbol between Kentucky & Japan features an old-school gate, koi pond & rock garden.",
      "poi_long_description": "Visitors say this park offers a peaceful atmosphere with a scenic pond, walking trails, and benches for quiet contemplation. They also highlight the park's Japanese-style garden, complete with wisteria, and its suitability for nature walks and photography.\n\nSome reviews mention the park can be unpleasant due to odors from a nearby water treatment plant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0250-72a9-bc0d-722fd13b9042.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-0250-72a9-bc0d-722fd13b9042",
        "storage_key": "property/6767906449167513/019e46e3-0250-72a9-bc0d-722fd13b9042.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.yukoen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6650325403298685781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yuko-en-on-the-elkhorn",
      "poi_latitude": "38.21964620000001",
      "poi_longitude": "-84.5644745",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 502-603-9454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1630b55f1990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1630b55f1990",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1630b55f1990.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqWKPeqc_QogRVeNfKLizSlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f6745101-702b-4815-8105-ac5f90412969",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Toyota 608 Security Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16137403239676851920&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "toyota-608-security-building",
      "poi_latitude": "38.25972060000001",
      "poi_longitude": "-84.54133379999999",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyS-YFqQ_QogR0DYtMr-S898",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_71e12753-3fed-4218-be7a-fbde2f43b42a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Toyota Motor North America (TMMK)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "151 Engineering Wy, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e2-ffaa-70ba-8f75-af09185e8efd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e2-ffaa-70ba-8f75-af09185e8efd",
        "storage_key": "property/6767906449167513/019e46e2-ffaa-70ba-8f75-af09185e8efd.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "http://toyota.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4399690407756164305&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "toyota-motor-north-america-tmmk",
      "poi_latitude": "38.2612533",
      "poi_longitude": "-84.5311498",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3MEtcY-QogR0ez_gx3XDj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b1aebec5-6ade-4614-a082-3367dbdb7ed5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Production Engineering Manufacturing Center (PEMC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "151 Engineering Wy, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18248479745978323744&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "production-engineering-manufacturing-center-pemc",
      "poi_latitude": "38.2494997",
      "poi_longitude": "-84.5374502",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJccXdEgA_QogRINPy9aSfP_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_113f5d54-22a0-4a4c-bb78-88c9a4ee99c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Toyota Motor Manufacturing Georgetown KY",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1101 Cherry Blossom Way, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13991800596936462298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "toyota-motor-manufacturing-georgetown-ky",
      "poi_latitude": "38.2565171",
      "poi_longitude": "-84.52957049999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs54nkk8_QogR2g9_3ILcLMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cdb24579-1197-4476-81a6-222e7466682e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "custom",
      "poi_name": "Ryder Office Complex",
      "poi_type": "Major Employers & Offices",
      "poi_address": "140 Industry Rd, Georgetown, KY 40324, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16883507937492812881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ryder-office-complex",
      "poi_latitude": "38.2729538",
      "poi_longitude": "-84.5363476",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-925-4268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e3-0ca2-70dc-96ea-1227fed512bb",
        "storage_key": "property/6767906449167513/019e46e3-0ca2-70dc-96ea-1227fed512bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSlZA6c-QogRUUS_OARFTuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_610199d525aad8f6f3799fe0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_6b28d08ea0d6b951988c6b35",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_92d0dede239bdf62d64ef015",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_bbb4331c7977386e6586b527",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_4f963336-a5b1-4f98-b558-ff43c6147c03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "rating": "5.0",
      "name": "Anna Long",
      "text": "Amy is an absolute angel. She has done a great job explaining and helping us get a home. We love it here and we love Amy",
      "date": "2025-12-08",
      "title": ""
    },
    {
      "id": "custom_61fb2336-c76d-4324-98ef-50556932c826",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "rating": "5.0",
      "name": "Stephanie Wright",
      "text": "Amy is the best! She is attentive, professional and personable. Amy has been a blessing into making this move easier for me. She made colonial gardens instantly feel like home to me. The property is clean, quiet and super cute. Highly recommend!",
      "date": "2025-07-24",
      "title": ""
    },
    {
      "id": "custom_94c8f077-5c08-43c8-90df-32d7bc566a39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "rating": "5.0",
      "name": "Alexander Lee",
      "text": "The atmosphere is relaxing, with clean units, good parking and friendly neighbors.  The staff are quick to respond to maintenance needs.  Our favorite thing about this place is the property manager, Amy.  She went the extra mile to help us through the application process.  On top of that, she's super personable, caring and accommodating.  We love this place!",
      "date": "2025-05-22",
      "title": ""
    },
    {
      "id": "custom_29240bc4-afa9-4f77-9048-1ffed925960e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "rating": "5.0",
      "name": "Teresa Morris",
      "text": "Amy was VERY helpful in assisting my daughter in getting an apartment. If I could give her 100 stars, I would!",
      "date": "2025-10-02",
      "title": ""
    },
    {
      "id": "custom_02b6d46e-8355-4c13-8cce-fc9bb5667709",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "rating": "5.0",
      "name": "Felicia_that_says_Bye",
      "text": "I feel truly at home here. It’s been such a wonderful experience since living here. We have been very lucky to have such a good manager, Amy!! She has been so understanding and helpful with anything we’ve needed help with and getting us a real home! I’m always so appreciative of how great she is to us and all of the staff have been since moving here. I love how responsive the maintenance is as well, we had a few issues and it got fixed much faster than any other place I’ve ever rented from!! The community is so comforting that I don’t stress if I forgot to lock my door and we’ve left our window open to sleep many times. I haven’t felt that comfortable in a home since I lived at home with my parents years ago. I recommend this place to people any chance I get because of how at home it feels and the price! I also love how we can have a safe place for my son to play with the equipment and the other kids are great with each other! I hope to live here for years until we can hopefully buy a home someday!!",
      "date": "2024-08-13",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ed0ea-ca8d-753a-800f-152071a021c1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Colonial Gardens Apartments Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513"
    },
    {
      "lead_collector_id": "019ed0ea-cb34-733a-b366-7a8172c5791e",
      "lead_source": "LANDING_PAGE",
      "name": "Colonial Gardens Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-georgetown-ky",
      "search_query": "apartments with in-unit laundry in Georgetown KY",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover apartments with in-unit laundry in Georgetown, KY. Experience ultimate comfort in Colonial Gardens with top-notch amenities.",
      "page_copy": "Finding the perfect place to call home that includes all the modern conveniences can make all the difference. At Colonial Gardens in Georgetown, KY, our apartments with in-unit laundry will make your daily routine more efficient and comfortable. Imagine the convenience of having your laundry facilities right at your fingertips, coupled with private patios or balconies, providing a relaxing view of the lush surroundings. \n\nColonial Gardens offers more than just in-unit laundry. Select units are fully remodeled and come with a deluxe appliance package. You will also find private entrances and a storage unit included, making our community a premium choice in Georgetown, KY. Experience the ease of comfortable living with all these thoughtful amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Georgetown KY Apartments with In-Unit Laundry",
      "seo_description": "Explore Colonial Gardens apartments in Georgetown, KY, featuring in-unit laundry and other premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-scott-county",
      "search_query": "air conditioned apartments near Scott County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Scott County",
      "h2_subtitle": "Stay cool in air conditioned apartments near Scott County. Explore Colonial Gardens' premium amenities.",
      "page_copy": "Are you searching for air conditioned apartments near Scott County that offer comfort and convenience? Look no further than Colonial Gardens in Georgetown, KY. Our community provides the perfect retreat with air conditioning in every apartment, ensuring you stay comfortable year-round. \n\nColonial Gardens isn't just about air conditioning; it's about providing an enriched lifestyle. Enjoy private entrances, a storage unit included with every apartment, and select fully remodeled units. With deluxe appliance packages and private patios or balconies, you can experience modern living near Scott County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Scott County",
      "seo_description": "Discover air conditioned apartments at Colonial Gardens near Scott County with top amenities for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "off-street-parking-apartments-georgetown",
      "search_query": "off-street parking apartments in Georgetown",
      "category": "Amenity",
      "h1_title": "Off-Street Parking Apartments in Georgetown",
      "h2_subtitle": "Convenient off-street parking apartments in Georgetown. Discover the benefits at Colonial Gardens today.",
      "page_copy": "Finding the right apartment involves more than just the interior features. At Colonial Gardens in Georgetown, KY, we understand that convenience is key. That's why we offer off-street parking apartments, making your daily commute hassle-free and providing peace of mind knowing your vehicle is parked safely. \n\nWhile off-street parking simplifies your transportation needs, Colonial Gardens enhances your living experience with a range of excellent amenities. Enjoy private patios or balconies, ample storage with included units, and the luxury of select fully remodeled apartments. Additionally, you'll appreciate private entrances and a deluxe appliance package that together create a truly delightful living environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Off-Street Parking Apartments in Georgetown",
      "seo_description": "Discover off-street parking apartments at Colonial Gardens in Georgetown with top-notch amenities for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "apartments-private-patios-40324",
      "search_query": "apartments with private patios in 40324",
      "category": "Amenity",
      "h1_title": "Apartments with Private Patios in 40324",
      "h2_subtitle": "Explore our apartments with private patios in the 40324 area at Colonial Gardens, where relaxation meets modern living.",
      "page_copy": "Imagine stepping out of your living room onto your own private patio, where you can unwind and enjoy the view. At Colonial Gardens in the 40324 area, our apartments with private patios offer a unique blend of privacy and comfort that enhances your living experience. Whether you're sipping morning coffee or hosting a small gathering, these outdoor spaces are perfect for any occasion.\n\nBeyond the luxury of private patios, Colonial Gardens provides numerous other amenities, such as private entrances and a storage unit included with every apartment. Select units boast full remodeling and a deluxe appliance package, further enhancing the modern living experience. Discover the charm and convenience of living in Colonial Gardens today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "40324 Apartments with Private Patios",
      "seo_description": "Find apartments with private patios in the 40324 area at Colonial Gardens, offering comfort and lush outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "fully-remodeled-apartments-georgetown",
      "search_query": "fully remodeled apartments Georgetown",
      "category": "Amenity",
      "h1_title": "Fully Remodeled Apartments in Georgetown",
      "h2_subtitle": "Experience the best of fully remodeled apartments in Georgetown at Colonial Gardens, where modern design meets comfort.",
      "page_copy": "Discover the beauty and functionality of fully remodeled apartments in Georgetown, KY, at Colonial Gardens. Our select units have been thoughtfully updated to offer stylish finishes and modern conveniences that cater to your lifestyle. From sleek kitchens with a deluxe appliance package to contemporary interiors, every detail has been considered.\n\nThe community at Colonial Gardens extends beyond the individual apartments. Enjoy private entrances, ample storage with included units, and the tranquility of private patios or balconies. These features, alongside the remodeled units, create an inviting home environment just minutes from the heart of Georgetown. Explore Colonial Gardens and see the transformation that awaits you.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fully Remodeled Apartments in Georgetown",
      "seo_description": "Explore fully remodeled apartments at Colonial Gardens in Georgetown, offering modern design and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-georgetown-ky",
      "search_query": "two bedroom apartments Georgetown KY",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Georgetown, KY",
      "h2_subtitle": "Explore our spacious two-bedroom apartments in Georgetown, KY at Colonial Gardens, designed for comfort and style.",
      "page_copy": "Colonial Gardens in Georgetown, KY, offers the perfect sanctuary with our spacious two-bedroom apartments. Ideal for families, roommates, or just extra room for a home office, these apartments offer generous floor plans designed to accommodate your needs. Each apartment is crafted with modern finishes and practical layouts that provide both functionality and aesthetics.\n\nBeyond the spacious interiors, Colonial Gardens enriches your living experience with exceptional community features. Enjoy the convenience of private entrances, private patios or balconies, and included storage units. For those seeking a touch of luxury, select units are fully remodeled and include a deluxe appliance package. Experience the best of two-bedroom living at Colonial Gardens.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Georgetown, KY",
      "seo_description": "Discover spacious two-bedroom apartments at Colonial Gardens in Georgetown, KY, with superb amenities and modern designs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "three-bedroom-floorplans-scott-county",
      "search_query": "three bedroom floorplans Scott County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floorplans in Scott County",
      "h2_subtitle": "Discover spacious three-bedroom floorplans in Scott County's Colonial Gardens, perfect for families and roommates seeking comfort and style.",
      "page_copy": "At Colonial Gardens, we offer expansive three-bedroom floorplans in Scott County to accommodate all your living needs. These thoughtfully designed spaces are perfect for families, roommates, or anyone needing extra room. Our apartments provide ample living areas, private patios or balconies, and storage units, ensuring you have both the space and privacy you desire.\n\nEach apartment is complemented by community features like private entrances and select units that are fully remodeled, complete with a deluxe appliance package. Situated in the heart of Scott County, our three-bedroom floorplans combine comfort and convenience, providing a perfect oasis to call home. Discover everything Colonial Gardens has to offer with our outstanding amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floorplans in Scott County",
      "seo_description": "Explore Colonial Gardens' spacious three-bedroom floorplans in Scott County, offering modern amenities and ample space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "apartments-near-georgetown-college-ky",
      "search_query": "apartments near georgetown college ky",
      "category": "School",
      "h1_title": "Apartments Near Georgetown College, KY",
      "h2_subtitle": "Discover convenience with apartments near Georgetown College, KY. Colonial Gardens offers ideal student living in a welcoming community.",
      "page_copy": "Colonial Gardens offers the perfect solution for those seeking apartments near Georgetown College, KY. Our community provides the ideal blend of comfort and convenience, just a stone's throw away from the college campus. Enjoy a quick commute, leaving you more time to focus on studies and campus life while relishing the peaceful haven our community offers.\n\nOur spacious apartments cater to a range of living styles and include features such as private entrances and patios or balconies. Select units boast fully remodeled interiors with a deluxe appliance package, perfect for students seeking modern amenities. With storage units included and a welcoming environment, Colonial Gardens is your perfect home base near Georgetown College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgetown College, KY",
      "seo_description": "Find convenient living at Colonial Gardens, with apartments close to Georgetown College, KY, offering modern amenities and a great community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "apartments-close-to-bctc-georgetown-scott-county",
      "search_query": "apartments close to bluegrass community and technical college georgetown scott county",
      "category": "School",
      "h1_title": "Apartments Near BCTC in Georgetown",
      "h2_subtitle": "Find convenient living at Colonial Gardens, close to Bluegrass Community and Technical College in Georgetown, Scott County.",
      "page_copy": "Located in the heart of Scott County, Colonial Gardens provides the ideal location for those attending Bluegrass Community and Technical College in Georgetown. Our apartments offer a short commute, allowing you more time to focus on your studies and enjoy college life. With a host of amenities designed for comfort and convenience, our community is perfect for students seeking a supportive living environment.\n\nAt Colonial Gardens, you'll find spacious apartments with private patios or balconies and private entrances. Selected units boast a deluxe appliance package and are fully remodeled for a modern living experience. Benefit from included storage units that enhance your living space, making us the premier choice for students at Bluegrass Community and Technical College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near BCTC in Georgetown, KY",
      "seo_description": "Live close to Bluegrass Community and Technical College at Colonial Gardens in Georgetown, Scott County, offering spacious apartments and easy commute.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "apartments-near-uk-healthcare-georgetown-scott-county",
      "search_query": "apartments near UK HealthCare Georgetown Scott County",
      "category": "Hospital",
      "h1_title": "Apartments Near UK HealthCare Georgetown",
      "h2_subtitle": "Experience convenient living at Colonial Gardens, located near UK HealthCare in Georgetown, Scott County.",
      "page_copy": "Colonial Gardens is your top choice for apartments near UK HealthCare in Georgetown, Scott County. Our community provides convenient access to healthcare services while offering a serene environment for you and your family. Whether you're a healthcare professional or simply desire close proximity to medical facilities, our location is ideal.\n\nResidents of Colonial Gardens enjoy spacious living with amenities such as private patios or balconies and private entrances. Some units come fully remodeled with a deluxe appliance package, ensuring a modern and comfortable lifestyle. With storage units included, our community meets the diverse needs of everyone seeking a home near UK HealthCare in Georgetown.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to UK HealthCare Georgetown",
      "seo_description": "Discover Colonial Gardens, offering comfortable apartments near UK HealthCare in Georgetown, Scott County, with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "apartments-near-scott-county-park-ky",
      "search_query": "apartments near Scott County Park KY",
      "category": "Park",
      "h1_title": "Apartments Near Scott County Park, KY",
      "h2_subtitle": "Enjoy living at Colonial Gardens, conveniently located near Scott County Park in KY. Experience serene living near nature.",
      "page_copy": "For those who cherish proximity to nature, Colonial Gardens offers apartments near Scott County Park, KY. Our community provides easy access to the park's scenic trails and recreational amenities, perfect for those who love outdoor activities and tranquil settings.\n\nOur apartments include private patios or balconies, allowing you to take in the natural surroundings from the comfort of your home. With private entrances and select units featuring a fully remodeled design, complete with a deluxe appliance package, Colonial Gardens combines modern living with nature’s tranquility. Enjoy the added benefit of included storage units, making our community the perfect choice for nature enthusiasts in Scott County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Scott County Park, KY",
      "seo_description": "Find your serene home at Colonial Gardens, offering apartments close to Scott County Park, KY, with modern amenities and nature access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "georgetown-rentals-by-great-crossing-park",
      "search_query": "Georgetown rentals by Great Crossing Park",
      "category": "Park",
      "h1_title": "Georgetown Rentals by Great Crossing Park",
      "h2_subtitle": "Discover Colonial Gardens, offering rentals near Great Crossing Park, Georgetown. Enjoy the ideal mix of nature and comfort.",
      "page_copy": "Colonial Gardens presents an ideal option for those seeking Georgetown rentals by Great Crossing Park. Our location offers the perfect blend of convenience and natural beauty, with easy access to the park's facilities and scenic views.\n\nOur community features spacious rentals with amenities such as private patios or balconies and private entrances for maximum comfort. Some select units have been fully remodeled, boasting a deluxe appliance package that elevates your living experience. Plus, with storage units included, Colonial Gardens caters to all your lifestyle needs, making it an excellent choice for those desiring close proximity to Great Crossing Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Georgetown Rentals Near Great Crossing Park",
      "seo_description": "Explore Colonial Gardens, offering Georgetown rentals next to Great Crossing Park. Enjoy modern amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167513",
      "source": "generator",
      "page_item_url": "yuko-en-elkhorn-nearby-apartments-scott-county",
      "search_query": "Yuko-En on the Elkhorn nearby apartments Scott County",
      "category": "Park",
      "h1_title": "Nearby Apartments Yuko-En on the Elkhorn",
      "h2_subtitle": "Live close to Yuko-En on the Elkhorn at Colonial Gardens. Discover serene apartments in Scott County.",
      "page_copy": "Colonial Gardens offers serene living with Yuko-En on the Elkhorn nearby, providing a unique opportunity to experience the beauty of this renowned Japanese garden. Located in Scott County, our community delivers an engaging ambience that harmonizes tranquility and modern living.\n\nEnjoy our range of amenities, including private patios or balconies, ideal for soaking in picturesque views. Private entrances and select fully remodeled units feature a deluxe appliance package, ensuring that you live in comfort and style. With storage units included, Colonial Gardens is the perfect place to call home if you want convenient access to the natural beauty of Yuko-En on the Elkhorn.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Yuko-En on the Elkhorn, Scott County",
      "seo_description": "Experience serene living at Colonial Gardens, near Yuko-En on the Elkhorn in Scott County, with modern amenities and garden access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12067673767"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5685513"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NH3PC4P4"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlNPWjF0UDlGQUNwWWpLZFNyUXljQmc9PSIsInZhbHVlIjoidUNtOFUrVGttdHAzUFphMU9rNElCUT09IiwibWFjIjoiNTY4N2E0OTg5Yjg0ZmUyNzExNDgzNDJkZDJlYjY5ODY4NDAzMTE2ZTI2YWY4MDEyZWExYmMwYTg1ZGNlOGY2ZSJ9"
    }
  ],
  "custom_repli_id": "12067673767",
  "custom_realpage_id": "5685513",
  "custom_google_gtm_id": "GTM-NH3PC4P4",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Prestige",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlNPWjF0UDlGQUNwWWpLZFNyUXljQmc9PSIsInZhbHVlIjoidUNtOFUrVGttdHAzUFphMU9rNElCUT09IiwibWFjIjoiNTY4N2E0OTg5Yjg0ZmUyNzExNDgzNDJkZDJlYjY5ODY4NDAzMTE2ZTI2YWY4MDEyZWExYmMwYTg1ZGNlOGY2ZSJ9",
  "custom_audioeye_site_id": "f4448d7b-834e-4c2d-b0ac-8681b92b2abf",
  "custom_audioeye_site_hash": "4ba1621c0dbcf3dc90abfb0d6d42b028"
};

export const generatedAt = '2026-09-23T21:38:02.908Z';
